// Libellés affichés selon la fonction de la personne connectée.

export function roleUtilisateur(user) {
  if (!user) return "";
  if (user.is_primary_admin) return "CEO";
  if (user.is_directeur) return "Directeur";
  if (user.is_superuser) return "Super administrateur";
  if (user.is_community_manager) return "Community Manager";
  if (user.is_secretaire) return "Secrétariat";
  if (user.is_brand_ambassador) return "Brand Ambassador";
  if (user.is_comptable) return "Comptable";
  if (user.is_staff) return "Enseignant";
  return "Élève";
}

export function espaceUtilisateur(user) {
  if (!user) return "ESPACE";
  if (user.is_primary_admin) return "ESPACE CEO";
  if (user.is_directeur) return "ESPACE DIRECTEUR";
  if (user.is_superuser) return "ESPACE ADMINISTRATEUR";
  if (user.is_community_manager) return "ESPACE COMMUNITY MANAGER";
  if (user.is_secretaire) return "ESPACE SECRÉTARIAT";
  if (user.is_brand_ambassador) return "ESPACE BRAND AMBASSADOR";
  if (user.is_comptable) return "ESPACE COMPTABLE";
  if (user.is_staff) return "ESPACE ENSEIGNANT";
  return "ESPACE ÉLÈVE";
}
